import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, VisuallyHidden } from '@chakra-ui/react';
import { useAgentBlocksTextContext } from '../../text/agent-blocks-text-context';
/**
 * The prose of an answer: the finding first, then the facts it rests on.
 * The live region is mounted with the answer and only filled when it is
 * ready, so a screen reader hears "Réponse prête" once instead of every token.
 */
export function AnswerBody({ children, isReady = false }) {
    const text = useAgentBlocksTextContext();
    return (_jsxs(Box, { fontSize: "sm", lineHeight: "1.62", color: "agent.fg", overflowWrap: "anywhere", css: {
            // The reset comes first and weighs no more than the spacing below it
            // (`:where` adds no specificity), so it never cancels the gap between
            // paragraphs and lists.
            '& :where(p, ul, ol)': { margin: 0 },
            '& > * + *': { marginTop: '3.5' },
            '& ul, & ol': {
                paddingInlineStart: '4.5',
                display: 'flex',
                flexDirection: 'column',
                gap: '1',
                lineHeight: '1.5',
            },
            // The reset strips list markers; an answer's facts keep theirs.
            '& ul': { listStyleType: 'disc' },
            '& ol': { listStyleType: 'decimal' },
            '& li::marker': { color: 'agent.fgDecorative' },
            '& strong': { fontWeight: 'semibold' },
        }, children: [children, _jsx(VisuallyHidden, { role: "status", "aria-live": "polite", children: isReady ? text.answer.ready : '' })] }));
}
